import { Field, Form, Formik } from "formik";
import React from "react";

import ButtonLoader from "@/Components/ButtonLoader";
import FieldErrorMessage from "@/Components/common/FieldErrorMessage";
import ModalPopUp from "@/Components/common/ModalPopUp";
import { RejectIcon } from "@/Components/Icons/RejectIcon";

/**
 * Renders a Reject Amendment Modal component.
 *
 * @param {object} open - determines whether the modal is open or not
 * @param {function} callbackFunc - callback function to handle form submission
 * @param {function} handleClose - callback function to handle modal close
 * @return {JSX.Element} the rendered Reject Amendment Modal component
 */
const RejectAmendmentModal = ({ open, callbackFunc, handleClose }) => {
  return (
    <ModalPopUp show={open} panelClass="max-w-[500px]">
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <h3 className="text-[20px] font-semibold leading-[normal] text-black">
            Reason for rejecting the amendment
          </h3>
          <button
            onClick={handleClose}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        <div>
          <Formik
            initialValues={{
              reason: "",
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validateOnMount={false}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              callbackFunc(values);
            }}
          >
            {({ submitForm, isSubmitting, errors, touched, isValid }) => (
              <Form>
                <div className="flex flex-col gap-6">
                  <div className="grid gap-3">
                    <label
                      htmlFor="email"
                      className="text-[14px] font-medium leading-[normal] text-txtColor"
                    >
                      Reason for Reject
                    </label>
                    <div className="flex flex-col">
                      <Field
                        type="text"
                        className={`h-[40px] w-full rounded-lg border border-lightGrey px-4 !outline-none !ring-0 focus:border-primary ${
                          errors.reason && touched.reason
                            ? "!border-red-500"
                            : ""
                        }`}
                        autoComplete="off"
                        name="reason"
                        placeholder="Enter Reason"
                        onKeyUp={(e) => {
                          if (e.keyCode === 13) {
                            submitForm();
                          }
                        }}
                        validate={(value) => {
                          if (!value) {
                            return "Reason is required";
                          }
                        }}
                        validateOnChange={true}
                      />
                      <FieldErrorMessage name="email" />
                    </div>
                  </div>
                  <div className="flex justify-end gap-[20px]">
                    <button
                      type="button"
                      className="transition-linear relative h-[45px] w-[120px] rounded-lg border border-red bg-red text-[14px] font-medium text-white hover:bg-none hover:text-red"
                      onClick={submitForm}
                    >
                      {isSubmitting ? <ButtonLoader /> : <span>Reject</span>}
                    </button>

                    <button
                      type="button"
                      className="transition-linear h-[45px] w-[120px] rounded-lg border border-primary bg-none text-[14px] font-medium text-primary hover:bg-primary hover:text-white"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default RejectAmendmentModal;
